import { render, staticRenderFns } from "./Jugadores.vue?vue&type=template&id=878aed66&scoped=true"
import script from "./Jugadores.vue?vue&type=script&lang=js"
export * from "./Jugadores.vue?vue&type=script&lang=js"
import style0 from "./Jugadores.vue?vue&type=style&index=0&id=878aed66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878aed66",
  null
  
)

export default component.exports